import axios from "axios";
import { authConfig, endpoint, multipartAuthConfig } from "./http";

export async function listMyListings({ accessToken, apiUrl }) {
  const response = await axios.get(endpoint(apiUrl, "/me/listings"), authConfig(accessToken));

  return response.data;
}

export async function getMyListing({ accessToken, apiUrl, listingId }) {
  const response = await axios.get(endpoint(apiUrl, `/me/listings/${listingId}`), authConfig(accessToken));

  return response.data;
}

export async function listListings({ apiUrl, query = "" }) {
  const response = await axios.get(endpoint(apiUrl, "/listings"), {
    params: query.trim() ? { q: query.trim() } : undefined,
  });

  return response.data;
}

export async function getListing({ apiUrl, listingId }) {
  const response = await axios.get(endpoint(apiUrl, `/listings/${listingId}`));

  return response.data;
}

export async function listMyFavorites({ accessToken, apiUrl }) {
  const response = await axios.get(endpoint(apiUrl, "/me/favorites"), authConfig(accessToken));

  return response.data;
}

export async function favoriteListing({ accessToken, apiUrl, listingId }) {
  const response = await axios.post(
    endpoint(apiUrl, `/listings/${listingId}/favorite`),
    {},
    authConfig(accessToken)
  );

  return response.data;
}

export async function unfavoriteListing({ accessToken, apiUrl, listingId }) {
  const response = await axios.delete(
    endpoint(apiUrl, `/listings/${listingId}/favorite`),
    authConfig(accessToken)
  );

  return response.data;
}

export async function reportListing({ accessToken, apiUrl, details, listingId, reason }) {
  const response = await axios.post(
    endpoint(apiUrl, `/listings/${listingId}/report`),
    {
      reason,
      details,
    },
    authConfig(accessToken)
  );

  return response.data;
}

export async function createSellerReview({ accessToken, apiUrl, comment, listingId, rating }) {
  const response = await axios.post(
    endpoint(apiUrl, `/listings/${listingId}/reviews`),
    {
      rating,
      comment,
    },
    authConfig(accessToken)
  );

  return response.data;
}

export async function createListing({ accessToken, apiUrl, listing }) {
  const response = await axios.post(endpoint(apiUrl, "/listings"), listing, authConfig(accessToken));

  return response.data;
}

export async function createListingWithImages({ accessToken, apiUrl, images, listing }) {
  const formData = new FormData();
  formData.append("listing_json", JSON.stringify(listing));
  images.forEach((image) => formData.append("images", image));

  const response = await axios.post(
    endpoint(apiUrl, "/listings/with-images"),
    formData,
    multipartAuthConfig(accessToken),
  );

  return response.data;
}

export async function uploadListingImage({ accessToken, apiUrl, image, listingId }) {
  const formData = new FormData();
  formData.append("image", image);

  const response = await axios.post(
    endpoint(apiUrl, `/listings/${listingId}/images`),
    formData,
    multipartAuthConfig(accessToken),
  );

  return response.data;
}

export async function analyzeListingImage({ accessToken, apiUrl, images }) {
  const formData = new FormData();
  images.slice(0, 3).forEach((image) => formData.append("image", image));

  const response = await axios.post(
    endpoint(apiUrl, "/ai/listings/analyze-image"),
    formData,
    multipartAuthConfig(accessToken),
  );

  return response.data;
}

export async function updateListing({ accessToken, apiUrl, listing, listingId }) {
  const response = await axios.patch(
    endpoint(apiUrl, `/listings/${listingId}`),
    listing,
    authConfig(accessToken),
  );

  return response.data;
}

export async function deleteListing({ accessToken, apiUrl, listingId }) {
  const response = await axios.delete(
    endpoint(apiUrl, `/listings/${listingId}`),
    authConfig(accessToken),
  );

  return response.data;
}

export async function publishListing({ accessToken, apiUrl, listingId }) {
  const response = await axios.post(
    endpoint(apiUrl, `/listings/${listingId}/publish`),
    {},
    authConfig(accessToken),
  );

  return response.data;
}

export async function markListingSold({ accessToken, apiUrl, listingId }) {
  const response = await axios.post(
    endpoint(apiUrl, `/listings/${listingId}/mark-sold`),
    {},
    authConfig(accessToken),
  );

  return response.data;
}

export async function rateListing({ accessToken, apiUrl, listingId }) {
  const response = await axios.post(
    endpoint(apiUrl, `/ai/listings/${listingId}/rate`),
    {},
    authConfig(accessToken),
  );

  return response.data;
}

export async function suggestListingImprovements({ accessToken, apiUrl, listingId }) {
  const response = await axios.post(
    endpoint(apiUrl, `/ai/listings/${listingId}/suggest-improvements`),
    {},
    authConfig(accessToken),
  );

  return response.data;
}

// Keep the checklist tied to the exact assessment whose score is displayed.
export function ratingImprovements(rating) {
  if (!rating) return null;
  return {
    listing_id: rating.listing_id,
    score: rating.score,
    suggestions: rating.suggestions || [],
  };
}
